'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_navigation_Button_Button = require('../../navigation/Button/Button.cjs.js');
const components_display_Icon_Icon = require('../Icon/Icon.cjs.js');
const react = require('@emotion/react');
const theme_Animation = require('../../../theme/Animation.cjs.js');
require('../../../theme/Colors.cjs.js');
const theme_Shadows = require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const styleEncapsulation = require('@zapier/style-encapsulation');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("Accordion", {
  root: (derivedState) => [
    react.css`
      ${styleMixins_reset.baseReset};
      position: relative;
      background-color: var(--zds-background-weaker);
      border: var(--zds-border-width-strong) solid transparent;
      border-radius: var(--zds-radius-medium);
      transition-property: box-shadow, border-color, background-color;
      transition-timing-function: ${theme_Animation.Animation.transitionTimingFunction};
      transition-duration: ${theme_Animation.Animation.transitionDuration};

      &:hover {
        background-color: var(--zds-background-selected);
      }
    `,
    derivedState.isOpen && styleEncapsulation.withModifier("highlighted", react.css`
          background-color: var(--zds-background-default);
          box-shadow: ${theme_Shadows.Shadows.elevation5};
        `)
  ],
  summary: (derivedState) => [
    react.css`
      ${styleMixins_reset.baseReset};
      display: block;
      padding: var(--zds-space-20);
      padding-${derivedState.toggleSide}: var(--zds-space-48);
      font: var(--zds-paragraph-header-3);
      color: var(--zds-text-default);
      cursor: pointer;

      // :focus-visible only works on the summary element,
      // so this expands the focus ring to the whole accordion.
      &::before {
        content: '';
        position: absolute;
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;
        border-radius: var(--zds-radius-medium);
      }

      &:focus-visible::before {
        border: var(--zds-border-focus);
        border-radius: var(--zds-radius-medium);
      }

      // Remove marker from browser / polyfills.
      &::-webkit-details-marker {
        display: none;
      }
    `
  ],
  content: (derivedState) => react.css`
    ${styleMixins_reset.baseReset};
    position: relative;
    z-index: 1;
    padding: 0 var(--zds-space-20) var(--zds-space-20);
    padding-${derivedState.toggleSide}: var(--zds-space-48);
    font: var(--zds-body-1-multiline);
    color: var(--zds-text-stronger);

    p {
      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
`,
  arrow: (derivedState) => react.css`
    ${styleMixins_reset.baseReset};
    position: absolute;
    top: var(--zds-size-20);
    ${derivedState.toggleSide}: var(--zds-space-16);
  `,
  fullPageButton: react.css`
    margin: 0 var(--zds-space-20) var(--zds-space-20);
  `
});
const FullPageButton = (props) => {
  const iconName = "arrowOffsite";
  return react.jsx(
    "div",
    { css: Styles.fullPageButton, "data-zds": true },
    react.jsx(components_navigation_Button_Button.Button, { color: "tertiary", href: props.href, iconBefore: iconName, isFullWidth: true, size: "medium", target: "_blank" }, "Open full page")
  );
};
const Accordion = (props) => {
  const { children, href, isInitiallyOpen, onToggle = () => {
  }, title, toggleSide = "left" } = props;
  const [isOpen, setIsOpen] = React.useState(!!isInitiallyOpen);
  const derivedState = {
    isOpen,
    toggleSide
  };
  React.useEffect(() => {
    if (props.isOpen !== void 0) {
      setIsOpen(props.isOpen);
    }
  }, [props.isOpen]);
  const handleClick = (e) => {
    e.preventDefault();
    onToggle({ isOpen: !isOpen });
    if (props.isOpen === void 0) {
      setIsOpen(!isOpen);
    }
  };
  return react.jsx(
    "details",
    { css: Styles.root(derivedState), open: isOpen, "data-zds": true },
    react.jsx(
      "summary",
      { css: Styles.summary(derivedState), onClick: handleClick, "data-zds": true },
      react.jsx(
        "span",
        { css: Styles.arrow(derivedState), "data-zds": true },
        react.jsx(components_display_Icon_Icon.Icon, { canAcceptPointerEvents: false, name: isOpen ? "arrowSmallUp" : "arrowSmallDown", size: 24 })
      ),
      title
    ),
    react.jsx("div", { css: Styles.content(derivedState), "data-zds": true }, children),
    isOpen && href && react.jsx(FullPageButton, Object.assign({}, props))
  );
};

exports.Accordion = Accordion;
//# sourceMappingURL=Accordion.cjs.js.map
